module.exports = __webpack_public_path__ + "static/media/s3.b3ba84b1.png";